import { useState, useEffect } from 'react';
import CardLike from './CardLike';

const VotingSection = ({ cardInfo }) => {
  const [currentTime, setCurrentTime] = useState(Math.floor(Date.now() / 1000));
  const [timeUntilChange, setTimeUntilChange] = useState(null);

  useEffect(() => {
    // Update current time every second
    const timer = setInterval(() => {
      setCurrentTime(Math.floor(Date.now() / 1000));
    }, 1000);

    // Calculate time until next state change
    if (cardInfo.contest_data) {
      if (currentTime < cardInfo.contest_data.voting_start) {
        // Time until voting starts
        setTimeUntilChange(cardInfo.contest_data.voting_start - currentTime);
      } else if (currentTime < cardInfo.contest_data.voting_end) {
        // Time until voting ends
        setTimeUntilChange(cardInfo.contest_data.voting_end - currentTime);
      }
    }

    return () => clearInterval(timer);
  }, [currentTime, cardInfo.contest_data]);

  if (!cardInfo.contest_data || Number(cardInfo.approvedGallery) !== 5) {
    return null;
  }

  return (
    <>
      {currentTime >= cardInfo.contest_data.voting_start && 
       currentTime <= cardInfo.contest_data.voting_end ? (
        <CardLike
          cardid={cardInfo.cardId}
          initialLiked={cardInfo.contest_data.is_liked}
          contestid={cardInfo.contest_data.contest_id}
        />
      ) : (
        <div className="text-sm text-gray-500">
          {currentTime < cardInfo.contest_data.voting_start ? (
            <>
              Voting is not open yet
              {timeUntilChange && (
                <span className="ml-1">
                  (opens in {Math.ceil(timeUntilChange / 60)} minutes)
                </span>
              )}
            </>
          ) : (
            "Voting period has ended"
          )}
        </div>
      )}
    </>
  );
};

export default VotingSection;